module.exports = __webpack_public_path__ + "static/play-button-eaa5463b8219e50612389c9d89516841.png";